import { render } from "./MainInventarios.vue?vue&type=template&id=2ba2caf2&scoped=true"
import script from "./MainInventarios.vue?vue&type=script&lang=js"
export * from "./MainInventarios.vue?vue&type=script&lang=js"

import "./MainInventarios.vue?vue&type=style&index=0&id=2ba2caf2&scoped=true&lang=css"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba2caf2"]])

export default __exports__